import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset} from '@netx/core-asset-next/schema';
import {
	assetPermissionChecker,
	PermissionMatrixName,
	PermissionName,
} from '@netx/core-permissions-next';

export const canViewAttributeHistoryForAsset = (asset?: IAsset): boolean => {
	if (!asset) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.READ,
		permissionName: PermissionName.VIEW_ATTRIBUTE_HISTORY,
	});
};
